"use strict";
/**
 * @name Tabs
 *
 * @description
 *  Used to show tabs and dynamic content to be displayed while a given tab is active
 *
 * @example
 * <Tabs
 *   mods='u-spaceRightSm'
 *   tabs={[
 *     {
 *       heading: 'Tab 1',
 *       content: <h1>Hello from Tab 1!</h1>
 *     },
 *     {
 *       heading: 'Tab 2',
 *       content: <h1>Hello from Tab 2!</h1>
 *     }
 *   ]}
 *  />
 *
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Button_1 = require("../Button");
var Tabs = function (_a) {
    var activeIndex = _a.activeIndex, setActiveIndex = _a.setActiveIndex, mods = _a.mods, tabs = _a.tabs, testId = _a.testId, renderOnload = _a.renderOnload, disableFirstAfterLoad = _a.disableFirstAfterLoad;
    var _b = React.useState(0), internalIndex = _b[0], setInternalIndex = _b[1];
    var _c = React.useState(false), initialized = _c[0], setInitialized = _c[1];
    var boolMods = !!mods;
    var _d = setActiveIndex
        ? [activeIndex, setActiveIndex]
        : [internalIndex, setInternalIndex], activeTabIndex = _d[0], setActiveTabIndex = _d[1];
    React.useEffect(function () {
        setInitialized(true);
    }, []);
    React.useEffect(function () {
        if (tabs[activeTabIndex].afterLoad && (!disableFirstAfterLoad || initialized)) {
            tabs[activeTabIndex].afterLoad();
        }
    }, [activeTabIndex]);
    return (React.createElement("div", { className: "Tabs ".concat(boolMods ? mods : ''), "data-testid": testId },
        React.createElement("ul", { className: "Tabs-header" }, tabs.map(function (tab, index) { return (React.createElement("li", { key: "Tabs-headerItem-".concat(index), className: "Tabs-headerItem ".concat(index === activeTabIndex ? 'is-active' : '') },
            React.createElement(Button_1.Button, { style: { color: 'inherit' }, onClick: function () { return setActiveTabIndex(index); }, type: "link" }, tab.heading))); })),
        React.createElement("div", { className: "Tabs-content" }, renderOnload ? (React.createElement("div", { key: "Tabs-contentItem-".concat(activeTabIndex), className: "Tabs-contentItem is-active" }, tabs[activeTabIndex].content)) : (React.createElement(React.Fragment, null, tabs.map(function (tab, index) { return (React.createElement("div", { key: "Tabs-contentItem-".concat(index), className: "Tabs-contentItem ".concat(index === activeTabIndex ? 'is-active' : '') }, tab.content)); }))))));
};
exports.default = Tabs;
